import React, { useEffect, useState } from 'react';

/**
 * CoffrasWeb: Coffras web sitesi projesi kapsam sunumu, 15 slayt.
 * Route: /r/coffras-web (sidebar YOK, tam ekran slayt).
 * Yeniden üretmek için: node src/pages/coffras-web/build.js (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function CoffrasWeb() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./coffrasWebHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Coffras · Web Projesi"
      srcDoc={html}
      style={fill}
    />
  );
}
